<template>
  <div>
    <div class="black-overlay"></div>
    <div :class="['modal', 'modal--welcomeback modal--zero-balance modal--purchase']" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_addon_game">
          <h1>{{ getTranslations.home_modals_post_game_free_play_wrong_answer_oh_no }}</h1>
          <p class="free_game_secondary_title">
             {{ getTranslations.home_modals_post_game_free_play_wrong_answer_wrong }}</p>
          <img class="addon_game_icon" src="/static/images/face_lost.png" alt="">        </div>
        <div class="modal__body modal_body_addon_game">
          <p class="free_game_main_p"> {{ getTranslations.home_modals_post_game_free_play_wrong_answer_won }}[{{ freeTrialPoints[0] }}] {{ getTranslations.home_modals_post_game_free_play_wrong_answer_points }}</p>
          <img class="free_game_image_lost" src="/static/images/modal_image.png" alt="">
          <div class="new_game_buttons_section ">

            <a @click.prevent="savePoints()" class="btn2 btn2--std btn2--small" style="cursor:pointer">{{ getTranslations.home_modals_post_game_free_play_prize_claim }}</a>
            <br> <br>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'PostGameWrongAnswer',
  data() {
    return {
      correctAnswersPoints: 0,
      gameVictoryPoints: 0,
      totalEarnedPoints: 0,
      homeScore: 0,
      awayScore: 0,
    };
  },
  created() {
    console.log('in PostGame created hook:');
    this.correctAnswersPoints = this.homePlayerRoundScore * 100;
    if (this.gameWinnerMSISDN === 'trial user') {
      this.homeScore = 1;
      this.gameVictoryPoints = 200;
    } else {
      this.awayScore = 1;
    }
    this.totalEarnedPoints = this.correctAnswersPoints + this.gameVictoryPoints;
  },
  mounted() {
    console.log('in RoundEnded free play mounted hook:');
    this.$nextTick(() => {
      /* eslint-disable */
      const vm = this;
      $(function() {
        $('#gif-click').hide();
        $('#click').click(function() {
          $('#click').hide();
          $('#gif-click').show();
          $('#pic-click').hide();
        });

        if ($('#click').data("clicked", true)) {
          $('#gif-click').click(function() {
            $('#click').show();
            $('#gif-click').hide();
            $('#pic-click').show();
          });
        }

      });
    });
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    goToRegistration() {
      if (this.freeTrialRedirectionUrl) { // if property "free.trial.redirection.url" exists redirect to it otherwise to register1
        window.location.href = `${this.freeTrialRedirectionUrl}?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=trial&totalEarnedPoints=${this.freeTrialPoints[0] || ''}`;
      } else {
        this.$router.push('/');
      }
    },
    savePoints() {
      this.storeRegistrationPoints({
        totalPoints: this.freeTrialPoints[0],
      });
      this.goToRegistration();
    },
  },
  computed: {
    ...mapState('common', [
      'freeTrialRedirectionUrl',
      'freeTrialPoints',
    ]),
    ...mapState('game', [
      'playersDetails',
      'homePlayerRoundScore',
      'awayPlayerRoundScore',
      'gameWinnerMSISDN',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'isEqualAmountOfCorrectAnswers',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
    determineWinnerCSSClass() {
      return (this.gameWinnerMSISDN === 'trial user') ? 'player1' : 'player2';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/PostGameWrongAnswer.vue